/**
 * We need this to prevent vite prod bundle failures:
 * https://github.com/vitejs/vite/issues/2139#issuecomment-854960323
 */
export const interopDefault = <T>(value: T): T => (value as any)?.default ?? value
